<!--
    描述：六算分析表首页
    时间：2020-05-15
    Created by ws
-->
<template>
	<div class="analysis-main-page">
		<div class="analysis-sheet-top">
			<el-button type="primary"
					   size="small"
					   class="filter-btn"
					   icon="el-icon-s-grid"
					   @click="doFilter">列过滤
			</el-button>
			<el-button type="primary"
					   size="small"
					   class="excel-btn"
					   plain
					   icon="el-icon-download"
					   v-if="roleBtns.includes('sheet-Excel')|| curSource === '1'"
					   @click="exportClk('excel')">导出Excel
			</el-button>
			<el-button icon="el-icon-upload"
					   size="small"
					   class="html-btn"
					    v-if="roleBtns.includes('sheet-Html')|| curSource === '1'"
					   @click="exportClk('html')">导出Html</el-button>
			<el-collapse v-model="activeNames"
						 @change="handleChange">
				<el-collapse-item name="1">
					<template slot="title">
						<div class="collapse-title">基本信息 <i class="ml10"
							   :class="activeNames.includes('1') ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i></div>
					</template>
					<div class="analysis-sheet-content"
						 v-show="showBasic">
						<analysis-info ref="analysisInfo"></analysis-info>
					</div>
				</el-collapse-item>
				<el-collapse-item name="2">
					<template slot="title">
						<div class="collapse-title">
							六算分析
							<i class="ml10"
							   :class="activeNames.includes('1') ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
							<el-select v-model="openTreeLevel"
									   class="ml10"
									   placeholder="请选择"
									   size="small"
									   @change="openTreeLevelOnChange">
								<el-option :value="0"
										   label="展开到一级"></el-option>
								<el-option :value="1"
										   label="展开到二级"></el-option>
								<el-option :value="2"
										   label="展开到三级"></el-option>
								<el-option :value="3"
										   label="展开到四级"></el-option>
							</el-select>
						</div>
					</template>
					<vxe-table ref="xTable"
							   auto-resize
							   border
							   highlight-current-column
							   highlight-hover-column
							   highlight-current-row
							   highlight-hover-row
							   row-id="proTreeId"
							   align="center"
							   show-overflow="tooltip"
							   column-min-width="96px"
							   :height="buttomGridHeight"
							   :header-cell-style="headerCellStyle"
							   :row-style="rowStyle"
							   :cell-style="cellStyle"
							   @header-cell-click="headerCellClick"
							   @cell-click="cellClick"
							   :loading="loading"
							   :data="busProContract"
							   :tree-config="{children: 'children', expandRowKeys: defaultExpandKeys }">
						<!-- expandRowKeys: defaultExpandKeys -->
						<vxe-table-column type="seq"
										  width="180"
										  title="序号"
										  tree-node></vxe-table-column>
						<vxe-table-column title="信息名称"
										  field="proTreeName"
										  width="230"
										  header-align="center"
										  align="left"></vxe-table-column>
						<vxe-table-column title="概算价"
										  v-for="(dynamic,index) in dynamicCol"
										  :key="index">
							<template v-slot:header>
								<vxe-radio name="n1"
										   v-model="radioIndex"
										   :label="index"
										   :content="dynamic.title"></vxe-radio>
							</template>
							<vxe-table-column :field="dynamic.param1.field"
											  :title="dynamic.param1.title"
											  :params="dynamic"
											  :width="dynamic.param1.width"
											  :header-align="dynamic.param1.headerAlign"
											  :align="dynamic.param1.align"></vxe-table-column>
							<vxe-table-column :field="dynamic.param2.field"
											  :title="dynamic.param2.title"
											  :params="dynamic"
											  :width="dynamic.param2.width"
											  :header-align="dynamic.param2.headerAlign"
											  :align="dynamic.param2.align">
								<template v-slot="{ row }">
									<span>{{ getInnerPercent(row, dynamic.param1.field) }}</span>
								</template>
							</vxe-table-column>
							<vxe-table-column :field="dynamic.param3.field"
											  :title="dynamic.param3.title"
											  :params="dynamic"
											  :width="dynamic.param3.width"
											  :header-align="dynamic.param3.headerAlign"
											  :align="dynamic.param3.align">
								<template v-slot="{ row }">
									<span>{{ getOutPercent(row, dynamic.param1.field) }}</span>
								</template>
							</vxe-table-column>
						</vxe-table-column>
					</vxe-table>
				</el-collapse-item>
			</el-collapse>
		</div>

		<!-- 列过滤弹窗 -->
		<el-dialog :visible.sync="dialogObj.visible"
				   :title="dialogObj.title"
				   :width="dialogObj.width"
				   :close-on-click-modal="false">
			<!-- 导出弹窗 -->
			<template v-if="dialogObj.visible && dialogObj.type === 'filter'">
				<div class="block-item">
					<el-checkbox :indeterminate="isIndeterminate"
								 v-model="checkAll"
								 @change="handleCheckAllChange($event, 'filter')">全选</el-checkbox> ( 注意： 基本信息模块默认导出 )
					<el-checkbox-group v-model="checkedColumns"
									   @change="handleCheck($event, 'filter')">
						<el-checkbox v-for="(item, index) in filterColumns"
									 :label="item.key"
									 :key="item.key">{{ item.label }}</el-checkbox>
					</el-checkbox-group>
				</div>
			</template>

			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="dialogObj.btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getProjectCostAnalysis } from '@/api/modules/analysisCharts'
import { exportExcel, dateFormat } from '@/utils/tools'
import { mapState } from 'vuex'

const analysisInfo = () => import('./analysis-sheet-info')
export default {
	name: 'Analysis-sheet',
	components: {
		analysisInfo
	},
	data() {
		return {
			priceTypeList: [
				'budgetPrice',
				'controlPrice',
				'bidPrice',
				'reportPrice',
				'primePrice',
				'confirmPrice'
			],
			//clickHeaderColumnIndex : '',    //表格头部标题点击column_index
			clickColumnId: '', //表格头部标题点击column_index
			clickRowId: '', //表格点击行row_id

			openTreeLevel: 2,

			showBasic: true,
			loading: false,
			radioIndex: 0,
			isActive: true,
			dynamicCol: [
				{
					title: '概算价',
					key: 'estimate',
					param1: {
						field: 'budgetPrice',
						title: '金额',
						width: 110,
						headerAlign: 'center',
						align: 'right'
					},
					param2: {
						field: 'innerPercent',
						title: '内部占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					},
					param3: {
						field: 'outPercent',
						title: '纵向占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					}
				},
				{
					title: '控制价',
					key: 'control',
					param1: {
						field: 'controlPrice',
						title: '金额',
						width: 110,
						headerAlign: 'center',
						align: 'right'
					},
					param2: {
						field: 'innerPercent',
						title: '内部占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					},
					param3: {
						field: 'outPercent',
						title: '纵向占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					}
				},
				{
					title: '中标价',
					key: 'bidding',
					param1: {
						field: 'bidPrice',
						title: '金额',
						width: 110,
						headerAlign: 'center',
						align: 'right'
					},
					param2: {
						field: 'innerPercent',
						title: '内部占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					},
					param3: {
						field: 'outPercent',
						title: '纵向占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					}
				},
				{
					title: '报审价',
					key: 'report',
					param1: {
						field: 'reportPrice',
						title: '金额',
						width: 110,
						headerAlign: 'center',
						align: 'right'
					},
					param2: {
						field: 'innerPercent',
						title: '内部占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					},
					param3: {
						field: 'outPercent',
						title: '纵向占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					}
				},
				{
					title: '初审价',
					key: 'before',
					param1: {
						field: 'primePrice',
						title: '金额',
						width: 110,
						headerAlign: 'center',
						align: 'right'
					},
					param2: {
						field: 'innerPercent',
						title: '内部占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					},
					param3: {
						field: 'outPercent',
						title: '纵向占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					}
				},
				{
					title: '审定价',
					key: 'after',
					param1: {
						field: 'confirmPrice',
						title: '金额',
						width: 110,
						headerAlign: 'center',
						align: 'right'
					},
					param2: {
						field: 'innerPercent',
						title: '内部占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					},
					param3: {
						field: 'outPercent',
						title: '纵向占比',
						width: 90,
						headerAlign: 'center',
						align: 'right'
					}
				}
			], //动态列

			// 默认展开层级
			defaultExpandKeys: [],
			// list 结构数据
			defaultList: [],
			busProContract: [],
			activeNames: ['1', '2'],
			//底部表格得高度
			buttomGridHeight: window.innerHeight - 540,
			dialogObj: {
				visible: false,
				title: '列过滤',
				width: '600px',
				type: 'filter',
				btnLoading: false
			},
			isIndeterminate: false,
			checkAll: true,
			checkedColumns: [
				'estimate',
				'control',
				'bidding',
				'report',
				'before',
				'after'
			],
			filterColumns: [
				{
					label: '概算价',
					key: 'estimate'
				},
				{
					label: '控制价',
					key: 'control'
				},
				{
					label: '中标价',
					key: 'bidding'
				},
				{
					label: '报审价',
					key: 'report'
				},
				{
					label: '初审价',
					key: 'before'
				},
				{
					label: '审定价',
					key: 'after'
				}
			]
		}
	},
	computed: {
		// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
		curSource() {
			return this.$route.query.source || '0'
		},

		curProjectId() {
			return this.$route.query.projectId || null
		},
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	watch: {
		// 监听项目ID 的变化
		curProjectId(val) {
			// console.log(val)
			this.getProjectCostAnalysis()
		}
	},
	created() {
		//this.defaultExpandKeys = ['1268442526560317442']
		this.getProjectCostAnalysis()
		this.loading = true
		this.findList().then(data => {
			this.busProContract = this.getGroupSummary(data)
			this.loading = false
		})
	},
	methods: {
		headerCellClassName({ column, columnIndex }) {
			return {
				backgroundColor: '#2db7f5',
				color: '#fff'
			}
		},
		rowStyle({ row, rowIndex }) {
			if (this.clickRowId == row.proTreeId)
				return { backgroundColor: '#e2d192' }
			else {
				if (row.proTreeLevelType == 0)
					return { backgroundColor: '#a5ddfd' }
				else if (row.proTreeLevelType == 1)
					return { backgroundColor: '#bce3fb' }
				else if (row.proTreeLevelType == 2)
					return { backgroundColor: '#ceebfb' }
			}
		},
		cellStyle({ row, rowIndex, column, columnIndex }) {
			let titles = [
				'概算价',
				'控制价',
				'中标价',
				'报审价',
				'初审价',
				'审定价'
			]
			if (
				column.params != null &&
				column.params.title == titles[this.radioIndex]
			) {
				return {
					//color : '#00469D',
					color: '#00469D',
					fontWeight: 700,
					//borderLeft: '1px solid #085694',
					backgroundColor: '#c9f3eea3'
				}
			}
		},
		headerCellStyle({ column, columnIndex }) {
			let titles = [
				'概算价',
				'控制价',
				'中标价',
				'报审价',
				'初审价',
				'审定价'
			]
			if (
				column.params != null &&
				column.params.title == titles[this.radioIndex]
			) {
				//return { backgroundColor: '#e2d192', }
				//return { backgroundColor: '#c9f3eea3', color : '#00469D', }
				return { backgroundColor: '#0073ab', color: '#00469D' }
			} else {
				return { backgroundColor: '#0073ab' }
			}
		},
		findList() {
			return new Promise(resolve => {
				setTimeout(() => {
					resolve(this.busProContract)
				}, 300)
			})
		},
		getGroupSummary(data) {
			this.$utils.eachTree(
				data,
				(row, index, items, path, parent, nodes) => {
					let children = row.children
					if (children && children.length) {
						// 合计子节点
						Object.assign(row, this.handleSummary(children))
					} else {
						row.num = 1
						if (index === items.length - 1) {
							// 全量汇总
							for (let len = nodes.length - 2; len >= 0; len--) {
								Object.assign(
									nodes[len],
									this.handleSummary(nodes[len].children)
								)
							}
						}
					}
				}
			)
			return data
		},
		//合并计算单独列
		handleSummary(children) {
			/*
                    return {
                        afterMoney: this.$utils.sum(children, 'afterMoney'),
                        area: Math.floor(this.$utils.sum(children, 'area')),
                        beforeMoney: parseInt(this.$utils.mean(children, 'beforeMoney'))
                    }
                    */
		},
		//六算分析接口
		getProjectCostAnalysis() {
			let that = this
			that.busProContract = []
			getProjectCostAnalysis({ id: that.curProjectId }).then(res => {
				//'1268442526560317442'
				if (res.code == 0) {
					//console.log(this.$utils.toArrayTree(res.data.grid,{ key: 'proTreeId', parentKey: 'proTreeParentId', children: 'children' }))
					that.$refs.analysisInfo.busProContractCosts = res.data.info
					that.initTreeTableData(res.data.grid)
				}
			})
		},
		initTreeTableData(list) {
			let that = this
			let resultList = []
			//proTreeLevelType = 3，树结构第4层节点信息
			let nodeLevel3List = list.filter(node => {
				return (
					node != null &&
					node.proTreeLevelType == 3 &&
					node.proTreeName.substring(0, 6) != '工程造价调整'
				)
			})
			//if(nodeLevel3List.length > 0) resultList = resultList.concat(nodeLevel3List)

			//proTreeLevelType = 2，树结构第3层节点信息，获取子节点（第4层节点信息）
			let nodeLevel2List = list.filter(node => {
				return node != null && node.proTreeLevelType == 2
			})
			nodeLevel2List.forEach(node => {
				//控制价
				let controlCostList = nodeLevel3List.filter(node3 => {
					return (
						node != null &&
						node.proTreeId == node3.proTreeParentId &&
						node3.phase == '1007002' &&
						node3.unitParentId != 0
					)
				})
				//中标价
				let bidCostList = nodeLevel3List.filter(node3 => {
					return (
						node != null &&
						node.proTreeId == node3.proTreeParentId &&
						node3.phase == '1007003' &&
						node3.unitParentId != 0
					)
				})
				//报审价
				let reportCostList = nodeLevel3List.filter(node3 => {
					return (
						node != null &&
						node.proTreeId == node3.proTreeParentId &&
						node3.phase == '1007004' &&
						node3.unitParentId != 0
					)
				})
				//初审价
				let primeCostList = nodeLevel3List.filter(node3 => {
					return (
						node != null &&
						node.proTreeId == node3.proTreeParentId &&
						node3.phase == '1007005' &&
						node3.unitParentId != 0
					)
				})
				//审定价
				let confirmCostList = nodeLevel3List.filter(node3 => {
					return (
						node != null &&
						node.proTreeId == node3.proTreeParentId &&
						node3.phase == '1007006' &&
						node3.unitParentId != 0
					)
				})

				let children = []
				controlCostList.forEach(node3 => {
					let bidCost = bidCostList.find(
						nodeV => nodeV.proTreeName == node3.proTreeName
					)
					let reportCost = reportCostList.find(
						nodeV => nodeV.proTreeName == node3.proTreeName
					)
					let primeCost = primeCostList.find(
						nodeV => nodeV.proTreeName == node3.proTreeName
					)
					let confirmCost = confirmCostList.find(
						nodeV => nodeV.proTreeName == node3.proTreeName
					)

					let item = {
						proTreeParentId: node.proTreeId,
						proTreeId: node3.proTreeId,
						proTreeName: node3.proTreeName,
						proTreeLevelType: 3,
						budgetPrice: '0.00',
						controlPrice: node3.unitCostValue.toFixed(2),
						bidPrice:
							typeof bidCost != 'undefined'
								? bidCost.unitCostValue.toFixed(2)
								: '0.00',
						reportPrice:
							typeof reportCost != 'undefined'
								? reportCost.unitCostValue.toFixed(2)
								: '0.00',
						primePrice:
							typeof primeCost != 'undefined'
								? primeCost.unitCostValue.toFixed(2)
								: '0.00',
						confirmPrice:
							typeof confirmCost != 'undefined'
								? confirmCost.unitCostValue.toFixed(2)
								: '0.00'
					}

					children.push(item)
				})

				resultList = resultList.concat(children)

				let controlCost = nodeLevel3List.find(
					node3 =>
						node.proTreeId == node3.proTreeParentId &&
						node3.phase == '1007002' &&
						node3.unitParentId == 0
				)
				let bidCost = nodeLevel3List.find(
					node3 =>
						node.proTreeId == node3.proTreeParentId &&
						node3.phase == '1007003' &&
						node3.unitParentId == 0
				)
				let reportCost = nodeLevel3List.find(
					node3 =>
						node.proTreeId == node3.proTreeParentId &&
						node3.phase == '1007004' &&
						node3.unitParentId == 0
				)
				let primeCost = nodeLevel3List.find(
					node3 =>
						node.proTreeId == node3.proTreeParentId &&
						node3.phase == '1007005' &&
						node3.unitParentId == 0
				)
				let confirmCost = nodeLevel3List.find(
					node3 =>
						node.proTreeId == node3.proTreeParentId &&
						node3.phase == '1007006' &&
						node3.unitParentId == 0
				)
				let item = {
					proTreeParentId: node.proTreeParentId,
					proTreeId: node.proTreeId,
					proTreeName: node.proTreeName,
					proTreeLevelType: 2,
					budgetPrice: parseFloat(node.budgetCostValueLevel2).toFixed(
						2
					),
					controlPrice:
						typeof controlCost != 'undefined'
							? controlCost.unitCostValue.toFixed(2)
							: '0.00',
					bidPrice:
						typeof bidCost != 'undefined'
							? bidCost.unitCostValue.toFixed(2)
							: '0.00',
					reportPrice:
						typeof reportCost != 'undefined'
							? reportCost.unitCostValue.toFixed(2)
							: '0.00',
					primePrice:
						typeof primeCost != 'undefined'
							? primeCost.unitCostValue.toFixed(2)
							: '0.00',
					confirmPrice:
						typeof confirmCost != 'undefined'
							? confirmCost.unitCostValue.toFixed(2)
							: '0.00'
				}
				resultList.push(item)
			})

			//proTreeLevelType = 1，树结构第2层节点信息
			let nodeLevel1List = list.filter(node => {
				return node != null && node.proTreeLevelType == 1
			})
			nodeLevel1List.forEach(node => {
				//累加价格
				let budgetPrice = 0,
					controlPrice = 0,
					bidPrice = 0,
					reportPrice = 0,
					primePrice = 0,
					confirmPrice = 0
				let nodeLevel2List = resultList.filter(v => {
					return node.proTreeId == v.proTreeParentId
				})
				nodeLevel2List.forEach(v => {
					budgetPrice += parseFloat(v.budgetPrice)
					controlPrice += parseFloat(v.controlPrice)
					bidPrice += parseFloat(v.bidPrice)
					reportPrice += parseFloat(v.reportPrice)
					primePrice += parseFloat(v.primePrice)
					confirmPrice += parseFloat(v.confirmPrice)
				})

				let item = {
					proTreeParentId: node.proTreeParentId,
					proTreeId: node.proTreeId,
					proTreeName: node.proTreeName,
					proTreeLevelType: 1,
					budgetPrice: budgetPrice.toFixed(2),
					controlPrice: controlPrice.toFixed(2),
					bidPrice: bidPrice.toFixed(2),
					reportPrice: reportPrice.toFixed(2),
					primePrice: primePrice.toFixed(2),
					confirmPrice: confirmPrice.toFixed(2)
				}
				resultList.push(item)
			})

			//proTreeLevelType = 0，树结构第1层节点信息
			let nodeLevel0List = list.filter(node => {
				return node != null && node.proTreeLevelType == 0
			})
			nodeLevel0List.forEach(node => {
				//累加价格
				let budgetPrice = 0,
					controlPrice = 0,
					bidPrice = 0,
					reportPrice = 0,
					primePrice = 0,
					confirmPrice = 0
				let nodeLevel1List = resultList.filter(v => {
					return node.proTreeId == v.proTreeParentId
				})
				nodeLevel1List.forEach(v => {
					budgetPrice += parseFloat(v.budgetPrice)
					controlPrice += parseFloat(v.controlPrice)
					bidPrice += parseFloat(v.bidPrice)
					reportPrice += parseFloat(v.reportPrice)
					primePrice += parseFloat(v.primePrice)
					confirmPrice += parseFloat(v.confirmPrice)
				})
				let item = {
					proTreeParentId: node.proTreeParentId,
					proTreeId: node.proTreeId,
					proTreeName: node.proTreeName,
					proTreeLevelType: 0,
					budgetPrice: budgetPrice.toFixed(2),
					controlPrice: controlPrice.toFixed(2),
					bidPrice: bidPrice.toFixed(2),
					reportPrice: reportPrice.toFixed(2),
					primePrice: primePrice.toFixed(2),
					confirmPrice: confirmPrice.toFixed(2)
				}
				resultList.push(item)
			})

			//resultList.sort((a, b)=> a.proTreeName.localeCompare(b.proTreeName, 'zh')); //z~a 排序

			this.defaultList = resultList
			that.busProContract = that.$utils.toArrayTree(resultList, {
				key: 'proTreeId',
				parentKey: 'proTreeParentId',
				children: 'children'
			})

			// 初始默认加载到3级
			this.openTreeLevelOnChange(2)
		},
		getInnerPercent(row, priceType) {
			let that = this
			if (row.proTreeLevelType == 0) return '100.00 %'
			// 以根节点数据为 分母项
			let data = that.busProContract[0]
			//分子
			let molecule = 0
			//分母
			let denominator = 0

			if (typeof row[priceType] !== 'undefined' && row[priceType]) {
				molecule = parseFloat(row[priceType])
			}

			if (typeof data[priceType] !== 'undefined' && data[priceType]) {
				denominator = parseFloat(data[priceType])
			}

			if (molecule === 0 || denominator === 0) return '/'
			let percent = ((molecule / denominator) * 100).toFixed(2)
			return percent + ' %'
		},
		getOutPercent(row, priceType) {
			let that = this
			//分子
			let molecule = 0
			//分母
			let denominator = 0

			//分子
			if (typeof row[priceType] !== 'undefined' && row[priceType]) {
				molecule = parseFloat(row[priceType])
			}
			//分母
			if (
				typeof row[that.priceTypeList[that.radioIndex]] !==
					'undefined' &&
				row[that.priceTypeList[that.radioIndex]]
			) {
				denominator = parseFloat(
					row[that.priceTypeList[that.radioIndex]]
				)
			}

			if (molecule === 0 || denominator === 0) return '/'
			let percent = ((molecule / denominator) * 100).toFixed(2)
			return percent + ' %'
		},
		handleChange(val) {
			if (val.length == 1 && val[0] == '2') {
				this.buttomGridHeight = window.innerHeight - 205
			}
			if (val.length == 2) {
				this.buttomGridHeight = window.innerHeight - 540
			}
		},
		cellClick({ row, rowIndex, column, columnIndex }) {
			this.clickRowId = row.proTreeId
		},
		headerCellClick(row, column) {
			if (row.column.parentId == null) this.clickColumnId = row.column.id
		},

		// 展开层级
		openTreeLevelOnChange(val) {
			this.defaultExpandKeys = []
			// this.busProContract = []

			let list = this.defaultList.filter(x => x.proTreeLevelType < val)
			list.map(x => {
				this.defaultExpandKeys.push(x.proTreeId)
			})

			// 重载表格
			this.$refs.xTable.reloadData(this.busProContract)
		},

		//导出
		exportClk(type) {
			let that = this
			//上面信息list
			let baseInfoTaleList = this.$refs.analysisInfo.getVxeTableData()
			let treeTableData = this.busProContract.concat()
			let listTableData = this.$utils.toTreeArray(treeTableData)
			if (listTableData.length == 0) return
			let data = listTableData.filter(v => {
				return v.proTreeParentId == 0
			})
			let treeTableList = []
			listTableData.forEach(v => {
				let cv = JSON.parse(JSON.stringify(v))
				//去掉children属性
				let { children, ...item } = cv
				item.innerPercentBudget = that.getInnerPercent(v, 'budgetPrice')
				item.innerPercentControl = that.getInnerPercent(
					v,
					'controlPrice'
				)
				item.innerPercentBid = that.getInnerPercent(v, 'bidPrice')
				item.innerPercentReport = that.getInnerPercent(v, 'reportPrice')
				item.innerPercentPrime = that.getInnerPercent(v, 'primePrice')
				item.innerPercentConfirm = that.getInnerPercent(
					v,
					'confirmPrice'
				)
				item.outPercentBudget = that.getOutPercent(v, 'budgetPrice')
				item.outPercentControl = that.getOutPercent(v, 'controlPrice')
				item.outPercentBid = that.getOutPercent(v, 'bidPrice')
				item.outPercentReport = that.getOutPercent(v, 'reportPrice')
				item.outPercentPrime = that.getOutPercent(v, 'primePrice')
				item.outPercentConfirm = that.getOutPercent(v, 'confirmPrice')
				treeTableList.push(item)
			})
			let saveName =
				'六算分析列表数据' + dateFormat('yyyy-MM-dd hh:ss:mm')
			exportExcel(
				'busProContract/sixCostExportExcle',
				{
					baseInfoTaleList: baseInfoTaleList,
					treeTableList: treeTableList,
					projectId: this.curProjectId,
					saveName: saveName,
					type: type
				},
				saveName
			)
		},

		// 列过滤
		doFilter() {
			this.dialogObj.visible = true
			this.dialogObj.type = 'filter'
		},

		// 列过滤全选事件
		handleCheckAllChange(status, type) {
			let _list = this.filterColumns.map(x => x.key)
			this.checkedColumns = status ? _list : []
			this.isIndeterminate = false
		},

		// 列过滤单选事件
		handleCheck(arr, type) {
			let checkedCount = arr.length
			this.checkAll = checkedCount === this.filterColumns.length
			this.isIndeterminate =
				checkedCount > 0 && checkedCount < this.filterColumns.length
		},

		// 确认列过滤
		doSave() {
			this.loading = true

			// 先重置列状态
			if (this.$refs.xTable) {
				this.$refs.xTable.resetColumn()
			}

			setTimeout(() => {
				this.dialogObj.visible = false
				let columns = this.$refs.xTable.getColumns()
				// 将指定列设置为隐藏状态
				columns.forEach(column => {
					if (column.params) {
						column.visible = false

						if (this.checkedColumns.includes(column.params.key)) {
							column.visible = true
						}
					}
				})

				if (this.$refs.xTable) {
					this.$refs.xTable.refreshColumn()
				}
				this.loading = false
			}, 1000)
		}
	}
}
</script>

<style lang="less" scoped>
.analysis-main-page {
	.analysis-sheet-top {
		padding: 0px 5px;

		.collapse-title {
			padding: 0px 3px;
			font-size: 16px;
			font-weight: 700;
		}

		.filter-btn {
			position: absolute;
			right: 230px;
			top: 8px;
			z-index: 99;
		}

		.excel-btn {
			position: absolute;
			right: 120px;
			top: 8px;
			z-index: 99;
		}

		.html-btn {
			position: absolute;
			right: 15px;
			top: 8px;
			z-index: 99;
		}
	}

	/deep/ .vxe-cell--title {
		color: #fff;
	}

	/deep/ .vxe-radio > input:checked + .vxe-radio--icon {
		background-color: #e6a23c;
		border-color: #e6a23c;
	}

	/deep/ .vxe-radio > input:checked + .vxe-radio--icon + .vxe-radio--label {
		color: #e6a23c;
	}

	/deep/ .el-collapse-item__arrow {
		display: none;
	}
}
</style>
